import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { NbInputModule } from '@nebular/theme';

@Component({
	selector: 'formly-nebular-number',
	template: `
		@if (operators().length) {
			<input nbInput fullWidth type="text" [formControl]="formControl" [attr.list]="operatorsListId" />
			<datalist [id]="operatorsListId">
				@for (operator of operators(); track operator.value) {
					<option [value]="operator.value">{{ operator.value }}</option>
				}
			</datalist>
		} @else {
			<input nbInput fullWidth type="number" [formControl]="formControl" />
		}
	`,
	imports: [ReactiveFormsModule, NbInputModule]
})
export class FormlyNebularNumberTypeComponent extends FieldType<FieldTypeConfig> {
	protected operatorsListId = `operators-${Math.random().toString(36).slice(2)}`;

	protected operators() {
		return this.field.options?.formState?.operators ?? [];
	}
}
